<template>
  <div>
    <div @click="changePerson" v-if="$storage.get('patient')">
      <el-row style="height: 1rem;background-color: #fff;margin-bottom: .1rem;font-size: .3rem;">
        <el-col :span="8">
          <div style="height: 1rem;line-height: 1rem;margin-left: .3rem">当前就诊人：</div>
        </el-col>
        <el-col :span="13">
          <div style="height: 1rem;line-height: 1rem;">
            <span>{{$storage.get('patient').clinic_patient_name}}</span>
            <span style="float: right;color:#e02c06;font-weight: 700;font-size: .32rem">换人</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="height: 1rem;line-height: 1.3rem;padding-left: .1rem;">
            <img src="static/img/huanren.png" style="width: .5rem;height: .5rem"/>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: .1rem;background-color: #f5f5f5;"></div>
    <div v-for="(item,index) in mealList" :key="index" @click="toDetails(item)">
      <Meal :name="item.项目名称" :describe="item.描述" :price="item.单价"></Meal>
    </div>
    <div class="noCard" v-if="!mealList.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无体检套餐</div>
    </div>
  </div>
</template>

<script>
  import Meal from '../common/Meal'
  import {getBodyCheckList} from '../../api/index'
    export default {
      data(){
        return{
          mealList:[]
        }
      },
      components:{
        Meal
      },
      created() {
        //修改标题
        document.title = '体检套餐'
        this.getList()
      },
      methods:{
        getList(){
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          getBodyCheckList().then(res=>{
            loading.close();
            this.mealList = res.Data
          })
        },
        toDetails(item){
          if(!this.$storage.get('patient')){
            this.$confirm('你还没有健康卡, 是否去注册?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push({path:'/personManage'})
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消',
                duration:3000,
                center:true,
                offset:200
              });
            });
            return
          }
          if(this.$storage.get('patients').length===1){
            this.$router.push({path:'/medicalPlanPay',query:{amount: item.单价,prjid: item.诊疗项目ID}})
            return;
          }
          this.$confirm('该体检套餐就诊人为：'+this.$storage.get('patient').clinic_patient_name, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '换人',
            type: 'warning'
          }).then(() => {
            this.$router.push({path:'/medicalPlanPay',query:{amount: item.单价,prjid: item.诊疗项目ID}})
          }).catch(() => {
            this.changePerson()
          });
        },
        //换人
        changePerson(){
          this.$router.push({path:'/selectPerson'})
        },
      }
    }
</script>

<style scoped>
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/medicalPlan.vue